import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { useMfaContext } from '@/components/mfa/providers/mfaProvider';

import { ResetMfaDialog } from '../../dialogs/resetMfaDialog';

export const ResetMfaCard = () => {
  const [isResetMfaDialogOpen, setIsResetMfaDialogOpen] = useState(false);
  const { handleResetMfa } = useMfaContext();

  const onResetMfa = async () => {
    setIsResetMfaDialogOpen(false);
    await handleResetMfa();
  };

  return (
    <>
      <ResetMfaDialog
        onClose={() => setIsResetMfaDialogOpen(false)}
        onConfirm={onResetMfa}
        open={isResetMfaDialogOpen}
      />
      <Card>
        <CardContent>
          <Typography variant="h5">Multi-factor authentication is enabled</Typography>
          <Typography variant="body1">
            Your account is protected using a time-based one-time password (TOTP).
          </Typography>
          <Box py={3}>
            <Button color="error" onClick={() => setIsResetMfaDialogOpen(true)} variant="outlined">
              Reset MFA
            </Button>
          </Box>
          <Typography variant="body1">
            Recovery instructions & reset options are managed by your organization admin.
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
